import { useTranslation } from 'react-i18next';

const useTaskTooltipTranslation = () => {
	const { t } = useTranslation();

	return {
		status: t('ROUTE_MONITORING.TOOLTIP.STATUS'),
		priority: t('ROUTE_MONITORING.TOOLTIP.PRIORITY'),
		eta: t('ROUTE_MONITORING.TOOLTIP.ETA'),
		etos: t('ROUTE_MONITORING.TOOLTIP.ETOS'),
		tos: t('ROUTE_MONITORING.TOOLTIP.TOS'),
		id: t('ROUTE_MONITORING.TOOLTIP.ORDER_ID'),
		to: t('ROUTE_MONITORING.TOOLTIP.TO'),
		address: t('ROUTE_MONITORING.TOOLTIP.ADDRESS'),
		noAddress: t('ROUTE_MONITORING.TOOLTIP.NO_ADDRESS'),
		timeWindow: t('ROUTE_MONITORING.TOOLTIP.TIME_WINDOW'),
		weight: t('ROUTE_MONITORING.TOOLTIP.WEIGHT'),
		items: t('ROUTE_MONITORING.TOOLTIP.ITEMS'),
		skills: t('ROUTE_MONITORING.TOOLTIP.SKILLS'),
		lateCompleted: t('ROUTE_MONITORING.TOOLTIP.LATE_COMPLETED'),
		lateNotCompleted: t('ROUTE_MONITORING.TOOLTIP.LATE_NOT_COMPLETED'),
		onTimeCompleted: t('ROUTE_MONITORING.TOOLTIP.ON_TIME_COMPLETED'),
		onTimeNotCompleted: t('ROUTE_MONITORING.TOOLTIP.ON_TIME_NOT_COMPLETED'),
		partialFulfilled: t('ROUTE_MONITORING.TOOLTIP.PARTIALLY_FULFILLED'),
		cancelled: t('ROUTE_MONITORING.TOOLTIP.CANCELLED'),
		earlyCompleted: t('ROUTE_MONITORING.TOOLTIP.EARLY_COMPLETED'),
		earlyNotCompleted: t('ROUTE_MONITORING.TOOLTIP.EARLY_NOT_COMPLETED'),
		tasks: t('ROUTE_MONITORING.TASKS'),
		orderPage: t('ROUTE_MONITORING.TOOLTIP.ORDER_PAGE'),
		arrivedAt: t('ROUTE_MONITORING.TOOLTIP.ARRIVED_AT'),
		taskType: t('ROUTE_MONITORING.TOOLTIP.TASK_TYPE'),
		pickup: t('ROUTE_MONITORING.TOOLTIP.PICKUP'),
		dropOff: t('ROUTE_MONITORING.TOOLTIP.DROP_OFF')
	};
};

export default useTaskTooltipTranslation;
